package kz.dentalcrm.app.navigation

import androidx.navigation3.runtime.NavKey
import kotlinx.coroutines.flow.MutableSharedFlow

internal class ComposeNavigator : AppNavigator {

    private val commands = MutableSharedFlow<NavCommand>(extraBufferCapacity = 64)

    override fun navigate(destination: AppRoute) {
        commands.tryEmit(NavCommand.NavigateTo(destination))
    }

    override fun navigateAndClearBackStack(destination: AppRoute) {
        commands.tryEmit(NavCommand.NavigateAndClear(destination))
    }

    override fun popUpTo(destination: AppRoute, inclusive: Boolean) {
        commands.tryEmit(NavCommand.PopUpTo(destination, inclusive))
    }

    override fun <T : Any> navigateBackWithResult(key: String, result: T, destination: AppRoute?) {
        commands.tryEmit(NavCommand.NavigateUpWithResult(key, result, destination))
    }

    override fun navigateUp() {
        commands.tryEmit(NavCommand.NavigateUp)
    }

    override suspend fun bind(
        backStack: MutableList<NavKey>,
        results: NavigationResults,
    ) {
        commands.collect { cmd ->
            when (cmd) {
                NavCommand.NavigateUp -> {
                    if (backStack.size > 1) backStack.removeAt(backStack.lastIndex)
                }

                is NavCommand.NavigateTo -> backStack.add(cmd.destination)

                is NavCommand.NavigateAndClear -> {
                    backStack.clear()
                    backStack.add(cmd.destination)
                }

                is NavCommand.PopUpTo -> {
                    val index = backStack.indexOfLast { it == cmd.destination }
                    if (index == -1) return@collect

                    val targetSize = if (cmd.inclusive) index else index + 1
                    while (backStack.size > targetSize) {
                        backStack.removeAt(backStack.lastIndex)
                    }
                }

                is NavCommand.NavigateUpWithResult -> {
                    results.set(cmd.key, cmd.value)
                    cmd.destination?.let { target ->
                        val index = backStack.indexOfLast { it == target }
                        if (index != -1) {
                            while (backStack.size > index + 1) {
                                backStack.removeAt(backStack.lastIndex)
                            }
                            return@collect
                        }
                    }

                    if (backStack.size > 1) backStack.removeAt(backStack.lastIndex)
                }
            }
        }
    }
}
